// Service-worker registration helper. Originally from Create React App;
// reworked for Vite so we no longer depend on process.env.PUBLIC_URL.
// The service worker itself is generated by `vite-plugin-pwa` (injectManifest
// strategy) using src/service-worker.js and is served from the site root.

const SW_URL = '/service-worker.js';

const isLocalhost = Boolean(
  typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '[::1]' ||
      window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/))
);

export function register(config) {
  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      if (isLocalhost) {
        checkValidServiceWorker(SW_URL, config);
      } else {
        registerValidSW(SW_URL, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // A new version is cached. Do not reload: screens live in
              // React state, so a reload dumps the user back on the main menu.
              // skipWaiting() in the service worker applies the update on the
              // next full page load.
              if (config && config.onUpdate) config.onUpdate(registration);
            } else if (config && config.onSuccess) {
              config.onSuccess(registration);
            }
          }
        };
      };

      // Download new deploys in the background. Do not check on focus or
      // visibility — those fire every time the user switches to another
      // program and back, and an update then reloaded the open screen.
      const checkForUpdate = () => {
        registration.update().catch(() => {
          // Network error or SW endpoint temporarily unreachable: ignore.
        });
      };

      setInterval(checkForUpdate, 15 * 60 * 1000);
      window.addEventListener('online', checkForUpdate);
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (response.status === 404 || (contentType != null && contentType.indexOf('javascript') === -1)) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      // Offline: nothing to do.
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}
